import './WhatsAppFAB.css';
import whatsappIcon from '../../assets/footer/whatsapp.svg';
import { useAppContext } from '../../context/AppState/AppContext';
const WhatsAppFAB = () => {
  const { jsonTexts } = useAppContext()
  const redirectTo = jsonTexts?.footer?.content?.contactContainer?.items[0]?.redirectTo;
  return (
    <div>
        <a href={redirectTo} className="whatsAppFAB-float" target="_blank">
         <img className="whatsAppFAB-my-float" alt="Wapp" src={whatsappIcon} />
        </a>
    </div>
  )
}
export default WhatsAppFAB